<script setup lang="ts">
import { useEnv } from '~library/composables'
import type { AppPublicImageProps } from './types'

const props = withDefaults(defineProps<AppPublicImageProps>(), {
  srcset: () => []
})

const { VITE_BASE_URL } = useEnv()

const srcUrl = computed(() => `${VITE_BASE_URL}${props.src}`)
const srcsetUrl = computed(() =>
  props.srcset.map((imageUrl) => `${VITE_BASE_URL}${imageUrl}`).join(', ')
)
</script>

<template>
  <img :alt="props.alt" :src="srcUrl" :srcset="srcsetUrl" />
</template>
